import React from 'react';
import SkillProgressBar from './SkillProgressBar'; // Update the path accordingly

const Skills = () => {
    return (
        <>
         <section id="skills" className="py-5 bg-light">
                <div className="container" data-aos="fade-up">

                    <div className="section-title text-center mb-5">
                        <h2 className="fw-bold text-uppercase position-relative d-inline-block pb-2" >Technical Skills</h2>
                        <p className="text-muted text-center mt-2">A structured breakdown of my competencies across research frameworks, core programming, and web systems.</p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-cpu fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">AI & Deep Learning</h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">PyTorch</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">CNN / ResNet</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Transformers / LSTM</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Adversarial ML</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Scikit-learn</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-broadcast fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">RF & Signal Processing</h5>
                                    </div>
                                    <div className="flex-wrap d-flex gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">SDR (USRP)</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">GNU Radio</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">RF Fingerprinting</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">IQ Imbalance & CFO</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">OFDM</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">SISO</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">SIMO</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-globe fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">Web & Databases</h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Laravel (PHP)</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">PostgreSQL / MySQL</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">RESTful APIs</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">JavaScript / jQuery</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">HTML5 / CSS3</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-code-slash fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">Languages</h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Python (NumPy, SciPy)</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">MATLAB</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">PHP</span>
                                        <span className="badge bg-white text-dark border py-1.5 px-2.5 rounded shadow-sm">C / C++ (Basics)</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-shield-check fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">Wireless & Security</h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Wireless Comms Theory</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Communication Security</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Cryptography</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Privacy Tech</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="rounded-3 p-2 me-3" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7' }}>
                                            <i className="bi bi-tools fs-4"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold">Tools & Systems</h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Linux / Ubuntu</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Git / GitHub</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Docker</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Wireshark</span>
                                        <span className="badge bg-white text-dark border px-2.5 py-1.5 rounded shadow-sm">Jupyter</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section id="hobbies" className="py-5">
                <div className="container" data-aos="fade-up">

                    <div className="section-title text-center mb-5">
                        <h3 className="fw-bold text-dark">Beyond the Lab & Studies</h3>
                        <p className="text-muted">What keeps me driven, collaborative, and balanced outside of my computational engineering commitments.</p>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-2 text-center">
                                <div className="card-body">
                                    <div className="d-inline-flex p-3 rounded-circle mb-3 text-white" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7 !important' }}>
                                        <i className="bi bi-people fs-3" style={{ color: '-moz-initial', color: '#34b7a7' }}></i>
                                    </div>
                                    <h5 className="fw-bold text-dark">Community Leadership</h5>
                                    <p className="text-muted small">Serving as the President of the Nepalese Student Association at Uark and advising the NWA Nepali Samaj allows me to build supportive cultural pathways and advocate for international scholars within Northwest Arkansas.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-2 text-center">
                                <div className="card-body">
                                    <div className="d-inline-flex p-3 rounded-circle mb-3 text-white" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7 !important' }}>
                                        <i className="bi bi-code-square fs-3" style={{ color: '#34b7a7' }}></i>
                                    </div>
                                    <h5 className="fw-bold text-dark">Open Source & Mentoring</h5>
                                    <p className="text-muted small">I stay connected to my web dev roots by contributing to open-source tools and volunteering time to mentor junior engineering students navigating systems development, relational databases, and core programming paradigms.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4 mx-auto">
                            <div className="card h-100 shadow-sm border-0 rounded-3 p-2 text-center">
                                <div className="card-body">
                                    <div className="d-inline-flex p-3 rounded-circle mb-3 text-white" style={{ backgroundColor: 'rgba(52, 183, 167, 0.1)', color: '#34b7a7 !important' }}>
                                        <i className="bi bi-compass fs-3" style={{ color: '#34b7a7' }}></i>
                                    </div>
                                    <h5 className="fw-bold text-dark">Active Exploring</h5>
                                    <p className="text-muted small">To balance long research desk sessions tinkering with software-defined radios, I recharge by exploring the scenic hiking trails of Northwest Arkansas, capturing landscapes, and staying active with recreational sports.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

           
        </>
    );
};

export default Skills;
